import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Topbar } from "@components";
import { PUBLIC_ROUTE } from "@router/route.constants";
import {
  SpinWrapper,
  RootContainer,
  HistoryContainer,
  HistoryBox,
  DateAndAmountContainer,
  Date,
  EmptyText,
  Amount,
  Time,
  ExpireBox,
  ExpireText,
  ExpiredTime,
} from "./History.style";
import { LIMITS } from "@constants";
import { api } from "@api";
import { Spin, message } from "antd";
import moment from "moment";
import { getFormattedNumber } from "@utils";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";

const { DEFAULT_PAGE, PAGE_SIZE } = LIMITS;

const History = () => {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [dataLength, setDataLength] = useState(0);

  const getHistory = useCallback(() => {
    setLoading(true);
    api
      .getSpinHistory({
        page,
        limit: PAGE_SIZE,
      })
      .then(({ spin_history, pagination }) => {
        setLoading(false);
        setDataLength(pagination.total);
        setData((prev) => [...prev, ...spin_history]);
      })
      .catch((errorMsg) => message.error(errorMsg));

  }, [page]);

  useEffect(() => {
    getHistory();
  }, [getHistory]);

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
  };

  return (
    <RootContainer>
      <Topbar title={t("spin.historyTitle")} goBack={goBack} />
      <InfiniteScroll
        dataLength={data.length}
        next={() => {
          setPage((prev) => prev + 1);
        }}
        hasMore={loading || data.length !== dataLength}
        loader={
          <SpinWrapper size={page === 1 ? 'large' : 'default'}>
            <Spin />
          </SpinWrapper>
        }
        endMessage={!loading && data.length === 0 && <EmptyText>{t("common.noRecord")}</EmptyText>}
      >
        <HistoryContainer >
          {data.map((history, index) => (
            <HistoryBox key={index}>
              <DateAndAmountContainer>
                <Date> {moment.unix(history.created_at).format("MMM DD, YYYY")} </Date>
                <Amount> {history.amount === 0 ? 'Thank you' : getFormattedNumber(history.amount) + " Ks."}  </Amount>
              </DateAndAmountContainer>
              <Time> {moment.unix(history.created_at).format("hh:mm:ss A")} </Time>
              <ExpireBox >
                <ExpireText> {t("spin.expiredLabel")} </ExpireText>
                <ExpiredTime> {moment.unix(history.bonus_expired).format("MMM DD, YYYY, hh:mm:ss A")} </ExpiredTime>
              </ExpireBox>
            </HistoryBox>
          ))
          }
        </HistoryContainer>
      </InfiniteScroll>
    </RootContainer>
  );
};

export default History;
